import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { RegistrationRequest } from '@us-registration/util-models';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RegistrationFacade } from '../../+state/registration.facade';

export const hasRegistrationRequestGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const registrationFacade = inject(RegistrationFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasRegistrationRequestGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  return registrationFacade.registrationRequest$.pipe(
    first(),
    map((registrationRequest: RegistrationRequest | undefined) => {
      if (!registrationRequest) {
        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });
        return false;
      }
      loggingService.debug('hasRegistrationRequestGuard', 'Success');
      return true;
    })
  );
};
